var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('article',[_c(_vm.getMediaType(_vm.file.properties),{tag:"component",attrs:{"file":_vm.file,"responsive":_vm.responsive,"media-label":_vm.mediaLabel,"image-meta-data":_vm.imageMetaData,"equal-media-height":_vm.equalMediaHeight,"appearance":_vm.appearance}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }